import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {TasksTemplateSingleVoyagesLazy} from "@containers/singleVoyage/taskTemplate/TasksTemplateSingleVoyages.lazy";
import {useAppContext} from "@context/appContext/hooks/useAppContext";
import {
    TrackableObjectsSingleVoyagesLazy
} from "@containers/singleVoyage/trackableObjects/TrackableObjectsSingleVoyages.lazy";

const TrackableObjectsSingleVoyagesPage = () => {

    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <TrackableObjectsSingleVoyagesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default TrackableObjectsSingleVoyagesPage;
